import { createMuiTheme } from "@material-ui/core/styles"

declare module "@material-ui/core/styles" {
  interface Palette {
    appContainerBackground: string
  }

  interface PaletteOptions {
    appContainerBackground: string
  }
}

const flexproTheme = createMuiTheme({
  typography: {
    fontFamily: [
      "Nexa",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h1: { fontWeight: "bold" },
    h2: { fontWeight: "bold" },
    h3: { fontWeight: "bold" },
    body1: { fontWeight: "normal" },
    body2: { fontWeight: "lighter" },
  },

  palette: {
    /* 🔵  Primary = deep green accent */
    primary: {
      main: "#1F3D2A", // Green — core brand colour
      dark: "#162A1D", // Slightly darker for hover / presses
    },

    /* 🟡  Secondary = gold accent */
    secondary: {
      main: "#C1A25E", // Gold — subtle highlights
      dark: "#8F753E", // Deeper gold for contrast
      light: "#D8C48C", // Soft gold tint (was previously #f7f9fd)
    },

    /* 🎨  Background & text */
    background: {
      default: "#F4F1E9", // Beige — luxurious, soft backdrop
    },
    text: {
      primary: "#000000", // Black — headings / body copy
      secondary: "#1F3D2A", // Green — supporting text & captions
    },

    /*  Preserved semantic colours  */
    error: { main: "#b11f24" },
    info: { main: "#C1A25E" }, // Uses gold accent for “info” chips, etc.
  },

  overrides: {
    MuiButton: {
      contained: {
        borderRadius: "2px",
        padding: "12px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "14pt",
        width: "180px",
        boxShadow: "none",
        "&:hover": { boxShadow: "none" },
      },
      text: {
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "14pt",
      },
    },
  },
})

export default flexproTheme
